import {
  appLogoAndroid,
  appLogoApple,
  appQrCode,
  appQrCodeBF,
  envelope,
  gtaAndroid,
  gtaAndroidBF,
  gtaApple,
  gtaAppleBF
} from '../shared/svgData';
import { checkMobile, cn, randomId } from '../shared/utils';

// COMP
import Button from '../Button';
import HighlightedText from '../HighlightedText';
import BrazeForm from '../shared/braze-form';

const Banner = ({
  cta,
  highlightedText = false,
  highlightedTextProps = {
    text: 'More Lines Added',
    type: 'ripple',
    containerClassName: '',
    textClassName: ''
  },
  description,
  input,
  inputPlaceholder,
  blackFriday,
  description2,
  percentage,
  appBannerOptions,
  salePromo,
  blackFridayPreview,
  bfpDescription,
  bfpDescription2,
  bfpDescription3,
  blackFriday24,
  app20off,
  DowloadCopy,
  buttonLink,
  buttonLink2,
  buttonLink3,
  buttonLink4,
  buttonLinkText,
  buttonLinkText2,
  buttonLinkText3,
  buttonLinkText4,
  gaBlockTitle,
  gaBlockName,
  gaBlockId,
  cyberMonday24,
  cyberMonday24BGVid,
  cyberMonday24BGVidType,
  saleExtra10,
  app20,
  endSale25,
  endSale25BGVid,
  endSale25BGVidType,
  endSale25Extra,
  endSale25ExtraImg,
  endSale25ExtraAlt,
  endSale25ExtraClasses,
  endSale25ExtraTextOnly,
  hideQr = false,
  disclaimer = false,
  disclaimerText = '*Full Price Only. Exclusions Apply.',
  clickable = false,
  link = '',
  className,
  student20,
  promoLockup,
  promoLockup2,
  buttonColour,
  xmasReturns,
  promoPercentoff,
  promoPercentoffBG,
  promoPercentoffColor,
  endSaleThin,
  gradient = endSaleThin || blackFridayPreview,
  resetAspect = false,
  buttonAbsolute = true,
  imageClasses = ''
}) => {
  return (
    <section
      id={`banner-section-${randomId()}`}
      className={
        `container my-24 lg:my-48 relative ${
          (blackFriday || app20off) && '!my-20 lg:!my-24'
        } ${
          (saleExtra10 || app20 || xmasReturns || promoPercentoff) &&
          '!mb-20 lg:!mt-24 lg:!mb-32'
        } ${blackFridayPreview && '!mt-0 mb-20 lg:mb-32 max-w-none p-0'} ${
          blackFriday24 && '!mb-0'
        }` + (appBannerOptions?.classes ? ' ' + appBannerOptions.classes : '')
      }
    >
      {(cyberMonday24 || (endSale25 && !endSale25Extra)) && (
        <video
          className={`absolute top-0 z-10 after:absolute after:top-0 after:w-full after:h-auto after:object-cover ${
            endSale25 ? 'after:opacity-50 w-full h-full object-cover' : ''
          }`}
          loop
          autoPlay
          muted
          playsInline
          preload="auto"
        >
          <source
            src={cyberMonday24BGVid || endSale25BGVid}
            type={cyberMonday24BGVidType || endSale25BGVidType}
          />
        </video>
      )}
      {saleExtra10 && (
        <a
          alt={buttonLinkText + gaBlockTitle}
          className={`absolute inset-0 z-10 w-full h-full hover:text-current ${
            cyberMonday24 && 'z-20'
          }`}
          href={buttonLink}
          data-name={gaBlockTitle}
          data-creative={gaBlockName}
          data-id={gaBlockId}
          data-position={'button-slot-' + 1}
          data-type="banner-button"
        ></a>
      )}
      {clickable && <a className="absolute inset-0 z-10" href={link} />}
      {app20 && (checkMobile.iOS() || checkMobile.Android()) && (
        <a
          alt={buttonLinkText + gaBlockTitle}
          className={`after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current`}
          href={
            checkMobile.iOS()
              ? 'https://apps.apple.com/us/app/sevenstore/id1179005758'
              : 'https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB'
          }
          data-name={gaBlockTitle}
          data-creative={gaBlockName}
          data-id={gaBlockId}
          data-position={'button-slot-' + 1}
          data-type="banner-button"
        ></a>
      )}
      <div
        className={cn(
          `px-10 pb-10 md:p-10 flex flex-col md:flex-row rounded-lg gap-6 ${
            app20 && 'banner-app-20-off text-white gap-10 h-[70vw] pt-10'
          } ${
            xmasReturns &&
            'banner-xmas-returns text-white gap-10 h-[70vw] pt-10'
          } ${
            promoPercentoff &&
            `${promoPercentoffBG} ${promoPercentoffColor} gap-10 h-[70vw] pt-10`
          } ${
            saleExtra10 &&
            'banner-extra-10 bg-black text-white gap-10 h-fit pt-10'
          }
          ${
            app20off &&
            'banner-app-20-off bg-black text-white gap-10 h-fit pt-10'
          } ${
            blackFriday || app20off
              ? 'banner-app-20 text-white lg:!items-center'
              : blackFridayPreview
              ? `${
                  endSale25ExtraTextOnly
                    ? 'banner-end-sale-25 !bg-black !text-white'
                    : ''
                } ${
                  (endSale25 || endSale25Extra) && !endSale25ExtraTextOnly
                    ? 'banner-end-sale-25 !bg-black !text-white'
                    : ''
                } ${
                  cyberMonday24 && 'banner-cm !bg-[#D2FF01] !text-black'
                } relative p-10 banner-bf-preview !rounded-none bg-black text-white !h-auto ${
                  (endSale25 || endSale25Extra) &&
                  '!aspect-[1/1] md:!aspect-[48/25] xl:!aspect-[165/65]'
                } md:aspect-[48/25] xl:aspect-[165/65] !flex-col !items-center !justify-end md:!justify-center !gap-52 md:!gap-0`
              : 'banner bg-[#E6E6E6]'
          } ${
            salePromo && '!h-[145vw] md:!h-auto'
          } justify-end md:items-end md:justify-between h-[135vw] md:h-96 lg:text-xl`,
          resetAspect ? '[aspect-ratio:auto]' : '',
          className
        )}
      >
        {promoLockup && (
          <HighlightedText
            text={cta}
            type={highlightedTextProps.type}
            containerClassName={highlightedTextProps.containerClassName}
            textClassName={highlightedTextProps.textClassName}
          />
        )}
        {blackFriday24 && (
          <a
            alt={buttonLinkText + gaBlockTitle}
            className={`after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current ${
              (cyberMonday24 || endSale25) && 'after:z-20'
            }`}
            href={
              buttonLink4
                ? buttonLink4
                : buttonLink3
                ? buttonLink3
                : buttonLink2
                ? buttonLink2
                : buttonLink
            }
            data-name={gaBlockTitle}
            data-creative={gaBlockName}
            data-id={gaBlockId}
            data-position={'button-slot-' + 1}
            data-type="banner-button"
          ></a>
        )}
        {cyberMonday24 && (
          <div
            className={
              'after:absolute after:inset-0 after:z-10 after:w-full after:h-full after:bg-gradient-to-t after:from-[#D2FF01] after:from-50% lg:after:from-60% xl:after:from-50%'
            }
          ></div>
        )}
        {endSale25 && !endSale25Extra && (
          <div
            className={
              'absolute inset-0 z-10 w-full h-full bg-gradient-to-t from-black/80 lg:from-50% xl:from-40%'
            }
          ></div>
        )}
        {gradient && (
          <div
            className={
              'absolute inset-0 z-0 w-full h-full pointer-events-none ' +
              'after:absolute after:inset-0 after:w-full after:h-full after:bg-gradient-to-t after:from-black/80 lg:after:from-40% xl:after:from-30% after:content-[""]' +
              (endSaleThin
                ? ' w-auto after:rounded-lg after:mx-6 md:after:mx-12 after:!w-auto'
                : '')
            }
          ></div>
        )}
        <div
          className={`${
            hideQr
              ? 'w-fit justify-center items-center'
              : 'md:w-[30rem] lg:w-[42rem]'
          } ${
            promoLockup ? 'relative h-96 md:h-[400px] xl:h-[500px]' : 'h-auto'
          } flex flex-col gap-4 ${
            blackFridayPreview &&
            '!w-auto items-center justify-center md:gap-2 relative xl:top-16'
          } ${blackFriday24 && '!top-0'} ${
            (cyberMonday24 || (endSale25 && !endSale25Extra)) &&
            '!top-14 md:!-top-10 xl:!top-20 -mx-8 z-10'
          } ${saleExtra10 && '!w-full md:!w-7/12'} ${app20 && '!w-fit'} ${
            (xmasReturns || promoPercentoff) && '!w-fit gap-0'
          } ${imageClasses}`}
        >
          {(endSale25Extra && !endSale25ExtraTextOnly) ||
          promoLockup ||
          student20 ||
          promoLockup2 ||
          endSaleThin ? (
            <img
              src={endSale25ExtraImg}
              alt={endSale25ExtraAlt}
              className={endSale25ExtraClasses}
            />
          ) : (
            <>
              <h3
                className={`${
                  blackFriday ||
                  app20off ||
                  saleExtra10 ||
                  app20 ||
                  xmasReturns ||
                  hideQr ||
                  promoPercentoff
                    ? `capitalize text-4xl lg:text-6xl font-extrabold ${
                        xmasReturns || app20 || promoPercentoff
                          ? 'text-6xl pb-3'
                          : 'pb-6 '
                      } tracking-[-0.8px]`
                    : blackFridayPreview || blackFriday24
                    ? `capitalize text-7xl lg:text-9xl ${
                        (cyberMonday24 || endSale25) &&
                        '!text-75xl lg:!text-8xl xl:!text-10xl'
                      } leading-none text-center font-bold font-sans tracking-[-1.8px] lg:tracking-[-1.966px]`
                    : 'uppercase text-xl font-bold pb-4'
                }`}
              >
                {endSale25 ||
                (highlightedText && (!blackFriday24 || !blackFridayPreview)) ? (
                  <HighlightedText
                    text={cta}
                    type={highlightedTextProps.type}
                    containerClassName={highlightedTextProps.containerClassName}
                    textClassName={highlightedTextProps.textClassName}
                  />
                ) : (
                  cta
                )}
              </h3>
              <h6
                className={`${
                  hideQr ? 'w-full text-center' : 'w-[26rem] lg:w-[30rem]'
                } ${
                  blackFriday ||
                  app20off ||
                  saleExtra10 ||
                  app20 ||
                  xmasReturns ||
                  hideQr ||
                  promoPercentoff
                    ? 'text-2xl lg:text-4xl font-base tracking-[-0.8px]'
                    : blackFridayPreview
                    ? `text-2xl lg:!text-7xl tracking-normal font-bold !w-full text-center pb-8 md:pb-12 ${
                        blackFriday24 && '!pb-0'
                      }`
                    : 'text-md lg:text-lg tracking-normal'
                } ${salePromo && '!w-full lg:!w-10/12'} ${
                  saleExtra10 && '!w-full lg:!w-10/12'
                } ${(xmasReturns || app20) && 'text-lg lg:text-4xl !w-full'} ${
                  promoPercentoff && 'text-xl font-bold md:font-base'
                }`}
              >
                {description}
                {(blackFriday || app20off) && (
                  <span className="block">
                    {description2}
                    <span className="font-extrabold text-md block">
                      {' '}
                      {percentage}
                    </span>
                  </span>
                )}
                {blackFridayPreview && (
                  <>
                    <span
                      className={`flex gap-2 justify-center items-center ${
                        endSale25ExtraTextOnly
                          ? 'flex-col md:gap-3'
                          : 'flex-row md:gap-6'
                      }`}
                    >
                      {bfpDescription}
                      <span
                        className={`${
                          endSale25ExtraTextOnly ? 'md:!text-2xl' : 'font-base'
                        }`}
                      >
                        {bfpDescription2}
                      </span>
                      {bfpDescription3}
                    </span>
                    {highlightedText && (
                      <div className="text-xl md:text-2xl mt-2 mb-1 md:mb-2.5 font-bold tracking-tight capitalize">
                        <HighlightedText
                          text={highlightedTextProps.text}
                          type={highlightedTextProps.type}
                          containerClassName={
                            highlightedTextProps.containerClassName
                          }
                          textClassName={highlightedTextProps.textClassName}
                        />
                      </div>
                    )}
                  </>
                )}
              </h6>
              {(blackFriday || blackFriday24 || saleExtra10 || app20off) &&
                !promoLockup2 && (
                  <p className="block !text-md font-base tracking-[-0.8px]">
                    {!endSale25 && "T&C's apply"}
                  </p>
                )}
              {disclaimer && (
                <p
                  className={`block !text-md font-base tracking-[-0.8px] ${
                    hideQr ? 'text-center' : ''
                  }`}
                >
                  {disclaimerText}
                </p>
              )}
              {endSale25 && endSale25ExtraTextOnly && (
                <p className="block !text-2xl font-bold tracking-normal uppercase">
                  {/*HighlightedText()*/}
                  Up To 70% Off
                </p>
              )}
              {/*
                endSale25ExtraTextOnly && (
                  <p className="block !text-md font-base tracking-[-0.8px]">
                    *Selected Lines Only. T&Cs Apply.
                  </p>
                )
              */}
              {blackFridayPreview && !blackFriday24 && (
                <p className="uppercase text-black bg-white py-2 px-8 rounded block text-center !text-xl md:!text-6xl font-bold tracking-normal">
                  {description2}
                </p>
              )}
              {input && (
                <BrazeForm
                  inputPlaceholder={inputPlaceholder}
                  envelope={envelope}
                />
              )}
            </>
          )}
        </div>
        {(saleExtra10 ||
          blackFriday24 ||
          promoLockup ||
          student20 ||
          endSaleThin) &&
          buttonLinkText && (
            <div
              className={cn(
                `flex flex-col md:flex-row items-center justify-center gap-4 w-full ${
                  promoLockup || student20 || endSaleThin
                    ? 'pb-10 px-10 md:p-0 md:!bottom-10 lg:!bottom-20'
                    : ''
                }`,
                buttonAbsolute ? 'md:absolute md:bottom-28' : ''
              )}
            >
              {[
                { link: buttonLink, text: buttonLinkText, slot: 1 },
                { link: buttonLink2, text: buttonLinkText2, slot: 2 },
                { link: buttonLink3, text: buttonLinkText3, slot: 3 },
                { link: buttonLink4, text: buttonLinkText4, slot: 4 }
              ]
                .filter(({ link, text }) => link && text)
                .map(({ link, text, slot }) => {
                  // Generate unique GA tracking values per button
                  const uniqueGaBlockTitle = `${
                    gaBlockTitle || 'Banner'
                  } Button ${slot}`;
                  const uniqueGaBlockName = `${
                    gaBlockName || 'BannerButton'
                  } ${slot}`;
                  const uniqueGaBlockId = `${
                    gaBlockId || 'banner'
                  }-btn-${slot}`;
                  return (
                    <Button
                      key={slot}
                      buttonColour={
                        cyberMonday24 || endSale25Extra
                          ? 'black'
                          : promoLockup
                          ? 'purple'
                          : 'white'
                      }
                      buttonLink={link}
                      buttonLinkText={text}
                      gaBlockTitle={uniqueGaBlockTitle}
                      gaBlockName={uniqueGaBlockName}
                      gaBlockId={uniqueGaBlockId}
                      buttonSlotNumber={slot}
                      buttonOptions={{
                        classes: {
                          wrapper: `w-full md:w-auto`
                        }
                      }}
                      buttonAdditionalClasses={{
                        classes: 'z-20'
                      }}
                    />
                  );
                })}
            </div>
          )}
        {app20 &&
          (checkMobile.iOS() || checkMobile.Android() ? (
            <Button
              buttonColour={buttonColour}
              buttonLink={
                checkMobile.iOS()
                  ? 'https://apps.apple.com/us/app/sevenstore/id1179005758'
                  : 'https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB'
              }
              buttonLinkText={buttonLinkText}
              gaBlockTitle={gaBlockTitle}
              gaBlockName={gaBlockName}
              gaBlockId={gaBlockId}
              buttonSlotNumber={2}
              buttonOptions={{
                classes: {
                  wrapper: `w-full md:w-auto`
                }
              }}
              buttonAdditionalClasses={{
                classes: 'z-20'
              }}
            />
          ) : (
            checkMobile.any() === null && (
              <div
                className={`hidden lg:flex text-end items-start h-72 ${
                  app20 && 'items-end justify-end'
                }`}
              >
                <h3
                  className={`mt-6 -mr-8 ${
                    app20 && '!w-1/3 mt-8 mr-0 self-start'
                  }`}
                >
                  GET THE APP
                </h3>
                <div className={`${app20 && 'w-72 h-auto'}`}>{appQrCodeBF}</div>
              </div>
            )
          ))}
        {!saleExtra10 &&
          !blackFriday24 &&
          !app20 &&
          !hideQr &&
          !xmasReturns &&
          !promoPercentoff && (
            <>
              <div
                className={`pb-6 md:pb-0 lg:h-full ${
                  blackFridayPreview &&
                  '!h-auto !w-full md:!w-auto relative md:absolute md:right-4 lg:right-20 md:bottom-4 lg:bottom-20 mx-0 !p-5 gap-3 md:gap-0 rounded bg-white text-black flex flex-row md:flex-col items-center justify-center'
                }`}
              >
                {blackFridayPreview && (
                  <p className="font-sans !text-md !font-bold !tracking-normal text-left lg:text-center">
                    {DowloadCopy}
                  </p>
                )}

                {checkMobile.iOS() && (
                  <div
                    id="gta-apple"
                    className={`md:h-24 lg:hidden ${
                      blackFridayPreview && 'flex justify-center w-1-2'
                    }`}
                  >
                    <a
                      href="https://apps.apple.com/us/app/sevenstore/id1179005758"
                      className="h-full"
                    >
                      {blackFriday || app20off
                        ? gtaAppleBF
                        : blackFridayPreview
                        ? appLogoApple
                        : gtaApple}
                    </a>
                  </div>
                )}
                {checkMobile.Android() && (
                  <div
                    id="gta-google"
                    className={`md:h-24 lg:hidden ${
                      blackFridayPreview && 'flex justify-center w-1-2'
                    }`}
                  >
                    <a
                      href="https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB"
                      className="h-full"
                    >
                      {blackFriday || app20off
                        ? gtaAndroidBF
                        : blackFridayPreview
                        ? appLogoAndroid
                        : gtaAndroid}
                    </a>
                  </div>
                )}
                {checkMobile.any() === null && (
                  <div
                    className={`hidden lg:flex text-end items-start h-72 ${
                      blackFridayPreview &&
                      'md:!flex items-center justify-center md:!h-40 lg:!h-44'
                    }`}
                  >
                    {!blackFridayPreview && (
                      <h3 className="mt-6 -mr-8">GET THE APP</h3>
                    )}
                    {blackFriday || app20off ? (
                      appQrCodeBF
                    ) : blackFridayPreview ? (
                      <div className="flex flex-row items-center justify-center h-full">
                        <span className="h-full">{appQrCode}</span>
                        <span className="flex flex-col items-center justify-center gap-4">
                          <span id="gta-apple">
                            <a
                              href="https://apps.apple.com/us/app/sevenstore/id1179005758"
                              className="h-full"
                            >
                              {appLogoApple}
                            </a>
                          </span>
                          <span id="gta-google">
                            <a
                              href="https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&gl=GB"
                              className="h-full"
                            >
                              {appLogoAndroid}
                            </a>
                          </span>
                        </span>
                      </div>
                    ) : (
                      appQrCode
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        {(xmasReturns || promoPercentoff) && (
          <Button
            buttonColour={buttonColour}
            buttonLink={buttonLink}
            buttonLinkText={buttonLinkText}
            gaBlockTitle={gaBlockTitle}
            gaBlockName={gaBlockName}
            gaBlockId={gaBlockId}
            buttonSlotNumber={2}
            buttonOptions={{
              classes: {
                wrapper: promoPercentoff ? 'w-full md:w-auto' : 'w-auto'
              }
            }}
            buttonAdditionalClasses={{
              classes: 'z-20'
            }}
          />
        )}
      </div>
    </section>
  );
};

export default Banner;
